module.exports = __webpack_public_path__ + "img/big3-5.f7764917.jpg";